/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'copy': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: '<path pid="0" d="M10.8 0H.6a.6.6 0 00-.6.6v10.2a.6.6 0 00.6.6h10.2a.6.6 0 00.6-.6V.6a.6.6 0 00-.6-.6zm-.6 10.2h-9v-9h9v9zM13.8 12.3v1.5h-1.5V15h2.1a.6.6 0 00.6-.6v-2.1h-1.2zM10.914 13.8H7.686V15h3.228v-1.2zM4.8 13.8v-1.5H3.6v2.1a.6.6 0 00.6.6h2.1v-1.2H4.8zM14.4 3.6h-2.1v1.2h1.5v1.5H15V4.2a.6.6 0 00-.6-.6zM15 7.686h-1.2v3.228H15V7.686z" _fill="#6D9AE8"/>'
  }
})
